import { render, staticRenderFns } from "./PersonaEntrada.vue?vue&type=template&id=93b0f110&"
import script from "./PersonaEntrada.vue?vue&type=script&lang=js&"
export * from "./PersonaEntrada.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports